import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { FlexCol } from '~/modules/artist-roster/components/flex/FlexCol';

import type { ChatMessage } from '../types';
import { Message } from './Message';

interface ThreadProps {
  messages: ChatMessage[];
  isThinking: boolean;
}

export function Thread({ messages, isThinking }: ThreadProps) {
  const { t } = useTranslation('data');
  const bottomRef = useRef<HTMLDivElement>(null);

  // Auto-scroll to bottom when new messages arrive or thinking state changes.
  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages, isThinking]);

  return (
    <FlexCol className="w-full gap-md p-sm pt-0">
      {messages.map((message) => (
        <Message key={message.id} message={message} />
      ))}

      {isThinking ? (
        <span
          className="animate-gradient-shimmer bg-clip-text text-body-sm text-transparent"
          style={{
            backgroundImage:
              'linear-gradient(90deg, oklch(var(--text-subtle)) 0%, oklch(var(--text-subtle)) 45%, oklch(var(--text-strong)) 50%, oklch(var(--text-subtle)) 55%, oklch(var(--text-subtle)) 100%)',
            backgroundSize: '300% 100%',
          }}
          role="status"
          aria-live="polite"
        >
          {t('musicIq.chatbot.thinking')}
        </span>
      ) : null}

      <div ref={bottomRef} />
    </FlexCol>
  );
}

Thread.displayName = 'Thread';
